// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Particle_Accessibility = require("../../particle/Particle_Accessibility.bs.js");

function accessibility(state) {
  if (state) {
    return Particle_Accessibility.make(undefined, undefined, undefined, undefined, undefined, false, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
  } else {
    return Particle_Accessibility.make(undefined, undefined, undefined, undefined, undefined, true, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
  }
}

exports.accessibility = accessibility;
/* No side effect */
